import constant from '../../constants/lang/zh-CN';
import newLang from '../newLang/zh';
/* eslint-disable max-len */

export default {
  cfmoto: {
    ...(newLang.cfmoto || {}),
    constant,
    title: 'CFMOTO RIDE',
    router: {
      title: {
        'binding-agreement': '绑车协议',
        introduce: '介绍',
        lamp: '辅助指示器',
        download: 'CFMOTO RIDE APP Download',
        orderConfirm: 'Order Confirmation',
        ebook: '电子书',
        list: '电子书',
        pdf: 'PDF',
        feedback: '反馈记录',
        'feedback-create': '反馈',
        'feedback-supplement': '补充反馈',
        'feedback-detail': '反馈详情',
        'feedback-result': '反馈',
        guide: '帮助中心',
        'guide-restScreen': '息屏导航引导',
        'guide-overview': '功能概览',
        'guide-account': '关于账号',
        'guide-vehicle': '关于车辆',
        'guide-meterSetting': '如何进行仪表设置',
        'guide-vehicleSetting': '如何进行车辆设置',
        'guide-findNavigation': '如何导航寻车',
        'guide-vehicleNnavigation': '如何使用导航',
        'guide-cyclingRecord': '关于骑行记录',
        'guide-vehicleExperience': '如何进行车辆体检',
        'guide-useSetting': '如何进行APP通用设置',
        'guide-notice': '如何查看并设置消息通知',
        'guide-about': '关于APP',
        help: '帮助与反馈',
        'help-detail': '问题详情',
        'myCar-unbinding': '申请解绑',
        'myCar-unbinding-result': '申请解绑',
      },
    },
    binding: {
      title: `协议`,
      text1: '1.远程信息处理服务',
      text2: 'CFMOTO Powersports, Inc.(以下简称“CFMOTO”)为购买CFMOTO车辆的客户(以下简称“客户”)提供车辆远程信息处理服务。为提供该服务，CFMOTO将收集、使用车辆在相关时间段内记录的与车辆状态及客户驾驶行为相关的数据。主要涉及以下数据：',
      text3: '客户驾驶行为数据：包括加速、减速、车速、压弯、最后一次驾驶时间、最后一次驾驶里程。',
      text4: '车辆状态数据：指车辆的实时状态，包括行驶模式、剩余燃油、即时燃油经济性、行驶里程、车辆实时档位、发动机转速、胎压、胎温、电池激活电压数据、冷却液温度、电子锁状态、智能设备软件版本、智能设备信号强度、仪表板当前设置。',
      text5: '车辆报警数据：当车辆状态的某些数值超过预设值时发送报警数据，如发动机温度、超速、行驶时间过长、冷却液温度过高、车辆运动异常、胎压异常、振动、倾倒、碰撞等。',
      text6: '车辆故障信息：指车辆内部各部件上报的故障代码。',
      text7: '车辆位置数据：指车辆的具体地理位置。',
      text8: '1.1.通过CFMOTO RIDE App为客户提供与车辆相关的服务。',
      text9: '1.1.1.客户可以通过CFMOTO RIDE App远程管理车辆(包括查看车辆位置、设置车辆信息、功能、远程控制车辆状态等)。',
      text10: '1.1.2.在导航过程中提供路线规划，包括计算与车辆的距离和以寻找车辆为目的的步行导航。',
      text11: '1.2.根据车辆状况向客户发送必要的通知。',
      text12: '1.2.1.CFMOTO将向客户发送车辆保养通知(例如，根据客户驾驶的总里程、客户购买车辆的时间、车辆保养所需的驾驶时间或行驶距离等)。',
      text13: '1.2.2.CFMOTO将根据车辆上报数据向客户发送车辆异常情况的通知：包括OEM的数据分析(取决于车型)，以便向客户提供服务和进行车辆的后续优化。',
      text14: '1.3.如果客户反馈车辆发生严重事故的，协助分析事故原因。',
      text15: '1.3.1.如果车辆发生严重事故，例如车辆在行驶过程中倾覆或侧翻，CFMOTO将根据客户的要求，协助客户澄清事故是由于车辆的缺陷还是其他情况造成的。客户应通过车辆销售协议中指定的当地经销商/销售合作伙伴向CFMOTO提交请求。',
      text16: '1.3.2.在现有数据允许的情况下，CFMOTO将评估分析与事故原因相关的数据，并向客户提供相应的报告。',
      text17: '1.4.协助客户在车辆遗失后取回车辆。',
      text18: '1.4.1.如果车辆丢失，CFMOTO将根据客户的要求，在可用的情况下，向客户提供车辆的位置数据和其他有用的车辆状态数据(如上次激活的位置、当前车辆状态等)。',
      text19: '1.4.2.客户应通过车辆销售协议中指定的当地经销商/销售合作伙伴向CFMOTO提交请求。',
      text20: '1.5.报告售后问题。',
      text21: '1.5.1.在车辆部件发生故障时，CFMOTO远程收集车辆发送的错误代码通知，并应客户要求直接向客户提供相关信息。',
      text22: '1.5.2.客户应通过车辆销售协议中指定的当地经销商/销售合作伙伴向CFMOTO提交请求。',
      text23: '2.服务的限制和排除',
      text24: '2.1.需要明确指出的是，车辆的结构或其他技术的变化可能限制服务的提供，甚至使服务无法正常提供，因为远程信息处理服务取决于车辆数据的正确提供。',
      text25: '2.2.如因任何第三方数据或电信网络的性能而无法正常提供该服务的，CFMOTO不承担任何责任。',
      text26: '3.隐私',
      text27: '在处理与CFMOTO车辆相关的个人数据时，CFMOTO将遵守客户住所地适用的数据保护法规。CFMOTO的隐私政策条款载于本CFMOTO RIDE App。本须知作为隐私政策的补充，与隐私政策保持一致，本须知未涉及的与数据处理相关的内容，客户可参考隐私政策。',
      text28: '4.客户服务',
      text29: '4.1.客户可自主将其与隐私相关的问题、评论或疑虑发送至CFMOTORIDEAPP@cfmotousa.com或致函：CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, MN 55447。客户也可致电(888)823-6686联系CFMOTO客户关系部。',
      text30: '5.修订',
      text31: '5.1.CFMOTO保留随时修订本须知的权利，但我们将于修订前在CFMOTO RIDE App上发布修订版本和/或修订通知。',
    },
    atmosphere: {
      desTitle: '功能说明',
      setINfo: '新设置将在车辆上电后1-3分钟内生效，请确保车辆处于信号良好位置',
      setSuccess: '设置成功',
      sure: '确定',
      confirm: '确认',
      cancel: '取消',
      cContent: '还未保存设置，是否保存？',
      save: '保存设置',
      introduce1: '靠近自动解锁说明',
      introduce2: '极简下电说明',
      introduce3: '车辆迎宾说明',
      introduce4: '伴你回家说明',
      content1: {
        msg1: '功能开启后，手机打开蓝牙且APP保持运行，从远到近靠近车辆，车辆即可自动解锁上电',
        msg2: '若未正常解锁上电，按车辆上电按钮也可解锁上电',
        msg3: '靠近自动解锁在蓝牙断开前仅会触发一次',
      },
      content2: {
        msg1: '功能开启后，满足车辆熄火、车速为0且边撑落下三个条件后，车辆将在5秒后自动下电',
        msg2: '在自动下电期间启动车辆、车速不为0或收起边撑都会取消自动下电',
      },
      content3: {
        msg1: '功能开启后，车辆为下电状态时，手机打开蓝牙且APP保持运行或携带实体钥匙，从远到近靠近车辆时会触发车辆灯光闪烁迎宾',
        msg2: '为防止频繁触发导致车辆亏电，迎宾功能在30秒内连续触发2次后，需等30分钟后才会恢复',
      },
      content4: {
        msg1: '功能开启后，车辆下电后将自动打开远、近光灯10秒',
      },
    },
    ebook: {
      placeholder: '请输入车架号进行查询',
      switch: '语言切换',
      choice: '语言选择',
      empty: '暂无说明书',
      title: '电子说明书',
    },
    feedback: {
      label: {
        type: '反馈类型（单选）',
        content: '问题描述',
        fileList: '请上传图片',
        fileList2: '(最多4张图片/1个视频)',
        feedbackCreate: '点击去反馈',
        feedbackSupplement: '补充反馈',
        backHome: '返回首页',
        vehicle: '关联车辆',
        selectVehicle: '选择车辆',
      },
      placeholder: {
        'content.bug': '详细描述发生时间、APP版本、手机机型、操作路径及问题说明，有助于快速定位并排查问题哦~',
        'content.suggest': '欢迎提出宝贵建议，我们会认真考虑您的想法',
        'content.vehicle': '详细描述当前车辆情况，有助于快速定位并排查问题哦~',
        'content.other': '请描述发生时间、操作路径及问题说明',
        'content.supplement': '请补充问题说明',
        vehicle: '请选择车辆',
      },
      rules: {
        'type.required': '请选择反馈类型',
        'content.required': '请输入问题描述',
        'fileList.uploading': '上传中，请稍候',
        'fileList.maxSize': '上传文件过大',
        'fileList.overType': '不支持的格式',
        'fileList.maxCount': '上传数量超出限制',
        'fileList.acceptImageVideo': '选择图片时不能选择视频',
        'vehicle.required': '请选择车辆',
      },
      message: {
        empty: '当前暂无反馈记录哦~',
        finish: '已经到底了',
        uploadFailed: '上传失败',
        tip: '为保障您的账户安全，请勿在此提交个人敏感信息，如账户密码等',
        feedbackSuccess: '反馈已收到',
        'submit.error': '反馈失败',
        'submit.success': '反馈已收到',
      },
    },
    guide: {
      label: { giveFeedback: '未解决，我要反馈' },
    },
    help: {
      label: {
        history: '历史搜索',
        cancel: '取消',
        yes: '是',
        no: '否',
        unresolved: '仍无法解决？点击',
        submitFeedback: '提交反馈',
      },
      placeholder: {
        search: '搜索',
        'content.required': '请输入关键词',
      },
      message: {
        empty: '暂无相关内容',
        empty2: '建议更换关键词或',
        finish: '已经到底了',
        historyDelete: '是否删除全部历史搜索记录？',
        isHelpful: '这是否有帮助？',
      },
    },
    unbinding: {
      label: {
        vin: '车架号',
        realName: '你的真实姓名',
        email: '联系邮箱',
        phone: '联系电话',
        areaCode: '区号',
        identity: '身份证明',
        drivingLicense: '车辆行驶证',
        backHome: '返回首页',
        areaCodeTitle: '国家编号',
        latterTitle: '须知',
        agree: '同意',
        disagree: '不同意',
        agreeCheckLabel: '我已阅读并同意',
        agreeCheckTitle: '车辆解绑申请须知',
      },
      placeholder: {
        vin: '请输入车架号',
        realName: '请输入真实姓名',
        email: '请输入联系邮箱',
        phone: '请输入联系电话',
        identity: '身份证、驾驶证或护照等包含个人身份信息的证件主页',
        drivingLicense: '包含车主姓名及车架号码信息的证件主页',
      },
      rules: {
        'agree.required': '请阅读并同意',
        'vin.required': '请输入车架号',
        'vin.pattern': '车架号输入错误，请检查',
        'realName.required': '请输入真实姓名',
        'email.required': '请输入联系邮箱',
        'email.pattern': '邮箱格式错误，请检查',
        'phone.required': '请输入联系电话',
        'phone.pattern': '联系电话格式错误，请检查',
        'fileList.maxCount': '上传数量超出限制',
        'fileList.uploading': '上传中，请稍候',
      },
      message: {
        imgUploadFailed: '图片上传失败',
        securityMessage: '以上信息仅用于身份验证，CFMOTO保障您的信息安全',
        resultMessage: '我们将尽快核实申请材料，请及时关注通知栏或APP消息中心。',
      },
    },
  },
};
